import { Component, ErrorHandler, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { GlobalErrorHandlerService } from './core/services/global-error-handler.service';
import { ErrorPanelComponent } from './shared/components/error-panel/error-panel.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ErrorPanelComponent],
  templateUrl: './app.html',
})
export class App {
  readonly errorHandler = inject(ErrorHandler) as GlobalErrorHandlerService;
}
